module.exports = __webpack_public_path__ + "img/new.d25b848e.svg";